import { render, staticRenderFns } from "./messSendTable.vue?vue&type=template&id=38f58ee8&scoped=true"
import script from "./messSendTable.vue?vue&type=script&lang=js"
export * from "./messSendTable.vue?vue&type=script&lang=js"
import style0 from "./messSendTable.vue?vue&type=style&index=0&id=38f58ee8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f58ee8",
  null
  
)

export default component.exports